import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Icon } from 'src/components/ui'
import { shareBot } from 'src/utils/shareBot'

import styles from './Actions.module.scss'

interface ActionsProps {
  path: string
  color?: 'white' | 'black'
  variant?: 'back' | 'add-user' | 'share' | 'transactions'
}

const Actions = ({ path, color = 'white', variant = 'back' }: ActionsProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleNavigation = () => {
    if (variant === 'share' || variant === 'add-user') {
      shareBot(path || '')
      return
    }

    if (path === '..') {
      navigate(-1)
    } else {
      navigate(path, { state: { from: location.pathname } })
    }
  }

  return (
    <button onClick={handleNavigation} className={`${styles.back} ${styles[color]}`} type='button'>
      <Icon name={variant} />
    </button>
  )
}

export default Actions
